export const clientDashboard = {
  extends: 'Page',
  flow: 'y',
  minHeight: '100vh',
  background: 'surface',

  // Top nav — light, minimal
  ClientNav: {
    tag: 'nav',
    flow: 'x',
    align: 'center space-between',
    padding: 'A C',
    borderBottom: '1px solid surfaceBorder',
    background: 'surfaceMid',
    position: 'sticky',
    top: '0',
    zIndex: '10',
    '@mobileL': { padding: 'A' },

    NavLeft: {
      flow: 'x', gap: 'B', align: 'center',
      FirmLogo: {
        extends: 'Link',
        href: '/client-dashboard',
        text: 'TrustLegal',
        fontSize: 'B',
        fontWeight: '800',
        color: 'green',
        textDecoration: 'none',
      },
      NavLinks: {
        flow: 'x', gap: 'A', align: 'center',
        '@mobileL': { display: 'none' },
        NavCases: {
          text: '{{ clientDashNavCases | polyglot }}',
          fontSize: 'Z',
          color: (el, s) => s.root.clientDashboardTab === 'cases' ? 'green' : 'textSoft',
          fontWeight: (el, s) => s.root.clientDashboardTab === 'cases' ? '600' : '400',
          cursor: 'pointer',
          onClick: (e, el, s) => s.root.update({ clientDashboardTab: 'cases' }),
        },
        NavInvoices: {
          text: '{{ clientDashNavInvoices | polyglot }}',
          fontSize: 'Z',
          color: (el, s) => s.root.clientDashboardTab === 'invoices' ? 'green' : 'textSoft',
          fontWeight: (el, s) => s.root.clientDashboardTab === 'invoices' ? '600' : '400',
          cursor: 'pointer',
          onClick: (e, el, s) => s.root.update({ clientDashboardTab: 'invoices' }),
        },
        NavDocs: {
          text: '{{ clientDashNavDocuments | polyglot }}',
          fontSize: 'Z',
          color: (el, s) => s.root.clientDashboardTab === 'documents' ? 'green' : 'textSoft',
          fontWeight: (el, s) => s.root.clientDashboardTab === 'documents' ? '600' : '400',
          cursor: 'pointer',
          onClick: (e, el, s) => s.root.update({ clientDashboardTab: 'documents' }),
        },
        NavMessages: {
          text: '{{ clientDashNavMessages | polyglot }}',
          fontSize: 'Z',
          color: (el, s) => s.root.clientDashboardTab === 'messages' ? 'green' : 'textSoft',
          fontWeight: (el, s) => s.root.clientDashboardTab === 'messages' ? '600' : '400',
          cursor: 'pointer',
          onClick: (e, el, s) => s.root.update({ clientDashboardTab: 'messages' }),
        },
      },
    },
    NavRight: {
      flow: 'x', gap: 'Z', align: 'center',
      ThemeToggle: {},
      ClientAvatar: {
        width: 'B',
        height: 'B',
        borderRadius: '100%',
        background: 'greenBg',
        border: '1px solid greenBorder',
        color: 'green',
        flow: 'x',
        align: 'center center',
        fontSize: 'Z',
        fontWeight: '700',
        text: (el, s) => (s.root.clientPortal.clientName || 'გ').charAt(0),
      },
      LogoutClientLink: {
        extends: 'Link',
        href: '/',
        text: '{{ clientDashLogout | polyglot }}',
        fontSize: 'Z',
        color: 'textMuted',
        textDecoration: 'none',
        onClick: (e, el, s) => s.root.update({ loggedIn: false }),
      },
    },
  },

  // Main content area
  ClientMain: {
    flow: 'y',
    padding: 'C',
    gap: 'B',
    maxWidth: 'J',
    margin: '0 auto',
    width: '100%',
    '@mobileL': { padding: 'A' },

    // Welcome header
    WelcomeHeader: {
      flow: 'y', gap: 'Z',
      WelcomeText: {
        tag: 'h1',
        text: (el, s) => '{{ clientDashWelcome | polyglot }} ' + s.root.clientPortal.clientName,
        fontSize: 'C',
        fontWeight: '800',
        color: 'text',
        '@mobileL': { fontSize: 'B' },
      },
      WelcomeSub: {
        text: '{{ clientDashWelcomeSub | polyglot }}',
        fontSize: 'Z',
        color: 'textMuted',
        lineHeight: '1.6',
      },
    },

    // Stats summary
    ClientStats: {
      flow: 'x',
      gap: 'A',
      flexWrap: 'wrap',
      ClientStat1: {
        extends: 'StatCard',
        StatValue: { text: '1' },
        StatLabel: { text: '{{ clientDashStatActiveCase | polyglot }}' },
      },
      ClientStat2: {
        extends: 'StatCard',
        StatValue: { text: '₾1,200', color: 'amber' },
        StatLabel: { text: '{{ clientDashStatPayable | polyglot }}' },
      },
      ClientStat3: {
        extends: 'StatCard',
        StatValue: { text: '2' },
        StatLabel: { text: '{{ clientDashStatDocument | polyglot }}' },
      },
      ClientStat4: {
        extends: 'StatCard',
        StatValue: { text: '{{ clientDashStatNextHearingValue | polyglot }}' },
        StatLabel: { text: '{{ clientDashStatNextHearing | polyglot }}' },
      },
    },

    // Tab content — Cases
    CasesView: {
      flow: 'y', gap: 'A',
      show: (el, s) => !s.root.clientDashboardTab || s.root.clientDashboardTab === 'cases',

      CasesSectionTitle: {
        flow: 'x', align: 'center space-between',
        TitleText: { tag: 'h2', text: '{{ clientDashMyCases | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'text' },
      },

      ActiveCase: {
        flow: 'y', gap: 'A', padding: 'B', background: 'surfaceMid', border: '1px solid surfaceBorder', borderRadius: 'Z',

        CaseHeader: {
          flow: 'x', align: 'center space-between',
          '@mobileL': { flow: 'y', gap: 'Z' },
          CaseNumType: {
            flow: 'x', gap: 'Z', align: 'center',
            CaseNum: { text: '#2024-047', fontSize: 'A', fontWeight: '700', color: 'text' },
            CaseType: { tag: 'span', text: '{{ clientDashCaseTypeCivil | polyglot }}', padding: 'Y Z', background: 'blueBg', color: 'blue', border: '1px solid blueBorder', borderRadius: 'Z', fontSize: 'Y' },
          },
          CaseStatusChip: { extends: 'StatusActive', text: '{{ clientDashStatusActive | polyglot }}' },
        },

        // Timeline / Progress
        ProgressSection: {
          flow: 'y', gap: 'Z',
          ProgressLabel: { text: '{{ clientDashProgressLabel | polyglot }}', fontSize: 'Z', color: 'textSoft' },
          ProgressTrack: {
            width: '100%', height: 'Y', background: 'surfaceBorder', borderRadius: 'Z',
            ProgressFill: { width: '60%', height: '100%', background: 'green', borderRadius: 'Z', transition: 'width 300ms' },
          },
        },

        // Case timeline steps
        TimelineSteps: {
          flow: 'y', gap: 'Z', padding: 'A 0',

          Step1: {
            flow: 'x', gap: 'Z', align: 'flex-start',
            StepDot: { width: 'Z', height: 'Z', borderRadius: '100%', background: 'green', flexShrink: '0', marginTop: 'Y' },
            StepContent: {
              flow: 'y', gap: 'Y',
              StepTitle: { text: '{{ clientDashStep1Title | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'text' },
              StepDate: { text: '{{ clientDashStep1Date | polyglot }}', fontSize: 'Y', color: 'textMuted' },
            },
          },
          Step2: {
            flow: 'x', gap: 'Z', align: 'flex-start',
            StepDot: { width: 'Z', height: 'Z', borderRadius: '100%', background: 'green', flexShrink: '0', marginTop: 'Y' },
            StepContent: {
              flow: 'y', gap: 'Y',
              StepTitle: { text: '{{ clientDashStep2Title | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'text' },
              StepDate: { text: '{{ clientDashStep2Date | polyglot }}', fontSize: 'Y', color: 'textMuted' },
            },
          },
          Step3: {
            flow: 'x', gap: 'Z', align: 'flex-start',
            StepDot: { width: 'Z', height: 'Z', borderRadius: '100%', background: 'green', flexShrink: '0', marginTop: 'Y' },
            StepContent: {
              flow: 'y', gap: 'Y',
              StepTitle: { text: '{{ clientDashStep3Title | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'text' },
              StepDate: { text: '{{ clientDashStep3Date | polyglot }}', fontSize: 'Y', color: 'textMuted' },
            },
          },
          Step4: {
            flow: 'x', gap: 'Z', align: 'flex-start',
            StepDot: { width: 'Z', height: 'Z', borderRadius: '100%', background: 'surfaceBorderStrong', flexShrink: '0', marginTop: 'Y' },
            StepContent: {
              flow: 'y', gap: 'Y',
              StepTitle: { text: '{{ clientDashStep4Title | polyglot }}', fontSize: 'Z', fontWeight: '500', color: 'textSoft' },
              StepDate: { text: '{{ clientDashStep4Date | polyglot }}', fontSize: 'Y', color: 'amber' },
            },
          },
          Step5: {
            flow: 'x', gap: 'Z', align: 'flex-start',
            StepDot: { width: 'Z', height: 'Z', borderRadius: '100%', background: 'surfaceBorderStrong', flexShrink: '0', marginTop: 'Y' },
            StepContent: {
              flow: 'y', gap: 'Y',
              StepTitle: { text: '{{ clientDashStep5Title | polyglot }}', fontSize: 'Z', fontWeight: '500', color: 'textMuted' },
              StepDate: { text: 'TBD', fontSize: 'Y', color: 'textMuted' },
            },
          },
        },

        // Assigned lawyer
        LawyerInfo: {
          flow: 'x', gap: 'Z', align: 'center', padding: 'A', background: 'surfaceBorder', borderRadius: 'Z',
          LawyerAvatar: {
            width: 'B',
            height: 'B',
            borderRadius: '100%',
            background: 'greenBg',
            color: 'green',
            flow: 'x',
            align: 'center center',
            fontSize: 'Z',
            fontWeight: '700',
            text: '{{ clientDashLawyerInitials | polyglot }}',
            flexShrink: '0',
          },
          LawyerDetails: {
            flow: 'y', gap: 'Y',
            LawyerName: { text: '{{ clientDashLawyerName | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'text' },
            LawyerRole: { text: '{{ clientDashLawyerRole | polyglot }}', fontSize: 'Y', color: 'textMuted' },
          },
        },
      },
    },

    // Tab content — Invoices
    InvoicesView: {
      flow: 'y', gap: 'A',
      show: (el, s) => s.root.clientDashboardTab === 'invoices',

      InvoicesSectionTitle: { tag: 'h2', text: '{{ clientDashInvoicesTitle | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'text' },

      UnpaidInvoice: {
        flow: 'x', align: 'center space-between', padding: 'A B', background: 'surfaceMid', border: '1px solid amberBorder', borderRadius: 'Z',
        '@mobileL': { flow: 'y', gap: 'A' },
        InvLeft: {
          flow: 'y', gap: 'Y',
          InvStatusRow: {
            flow: 'x', gap: 'Z', align: 'center',
            InvNum: { text: 'INV-2024-031', fontSize: 'Z', color: 'textMuted' },
            InvChip: { extends: 'StatusPending', text: '{{ clientDashUnpaid | polyglot }}' },
          },
          InvAmount: { text: '₾1,200', fontSize: 'C', fontWeight: '800', color: 'text' },
          InvMeta: {
            flow: 'y', gap: 'Y',
            InvCase: { text: '{{ clientDashInvCase1 | polyglot }}', fontSize: 'Z', color: 'textSoft' },
            InvDue: { text: '{{ clientDashInvDue1 | polyglot }}', fontSize: 'Z', color: 'amber', fontWeight: '500' },
          },
        },
        PayBtn: { extends: 'Button', text: '{{ clientDashPay | polyglot }}', theme: 'primary', padding: 'Z B', fontSize: 'Z', borderRadius: 'Z', cursor: 'pointer' },
      },

      PaidInvoice: {
        flow: 'x', align: 'center space-between', padding: 'A B', background: 'surfaceMid', border: '1px solid surfaceBorder', borderRadius: 'Z',
        '@mobileL': { flow: 'y', gap: 'A' },
        InvLeft: {
          flow: 'y', gap: 'Y',
          InvStatusRow: {
            flow: 'x', gap: 'Z', align: 'center',
            InvNum: { text: 'INV-2024-030', fontSize: 'Z', color: 'textMuted' },
            InvChip: { extends: 'StatusConfirmed', text: '{{ clientDashPaid | polyglot }}' },
          },
          InvAmount: { text: '₾640', fontSize: 'B', fontWeight: '700', color: 'textSoft' },
          InvMeta: {
            flow: 'y', gap: 'Y',
            InvCase: { text: '{{ clientDashInvCase2 | polyglot }}', fontSize: 'Z', color: 'textSoft' },
            InvDue: { text: '{{ clientDashInvPaidDate | polyglot }}', fontSize: 'Z', color: 'textMuted' },
          },
        },
      },
    },

    // Tab content — Documents
    DocumentsView: {
      flow: 'y', gap: 'A',
      show: (el, s) => s.root.clientDashboardTab === 'documents',

      DocsSectionTitle: { tag: 'h2', text: '{{ clientDashDocumentsTitle | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'text' },

      DocRow1: {
        flow: 'x', align: 'center space-between', padding: 'A B', background: 'surfaceMid', border: '1px solid surfaceBorder', borderRadius: 'Z',
        '@mobileL': { flow: 'y', gap: 'Z' },
        DocLeft: {
          flow: 'x', gap: 'Z', align: 'center',
          DocIcon: { extends: 'Icon', icon: 'document', width: 'B', height: 'B', color: 'green' },
          DocInfo: {
            flow: 'y', gap: 'Y',
            DocName: { text: '{{ clientDashDocName1 | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
            DocMeta: { text: '{{ clientDashDocMeta1 | polyglot }}', fontSize: 'Z', color: 'textMuted' },
          },
        },
        DownloadBtn: { extends: 'Button', text: '{{ clientDashDownload | polyglot }}', theme: 'ghost', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', cursor: 'pointer' },
      },

      DocRow2: {
        flow: 'x', align: 'center space-between', padding: 'A B', background: 'surfaceMid', border: '1px solid surfaceBorder', borderRadius: 'Z',
        '@mobileL': { flow: 'y', gap: 'Z' },
        DocLeft: {
          flow: 'x', gap: 'Z', align: 'center',
          DocIcon: { extends: 'Icon', icon: 'document', width: 'B', height: 'B', color: 'green' },
          DocInfo: {
            flow: 'y', gap: 'Y',
            DocName: { text: '{{ clientDashDocName2 | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
            DocMeta: { text: '{{ clientDashDocMeta2 | polyglot }}', fontSize: 'Z', color: 'textMuted' },
          },
        },
        DownloadBtn: { extends: 'Button', text: '{{ clientDashDownload | polyglot }}', theme: 'ghost', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', cursor: 'pointer' },
      },
    },

    // Tab content — Messages
    MessagesView: {
      flow: 'y', gap: 'A',
      show: (el, s) => s.root.clientDashboardTab === 'messages',

      MsgSectionTitle: { tag: 'h2', text: '{{ clientDashMessagesTitle | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'text' },

      ChatArea: {
        flow: 'y', gap: 'Z', padding: 'B', background: 'surfaceMid', border: '1px solid surfaceBorder', borderRadius: 'Z', minHeight: 'F',

        Msg1: {
          flow: 'y', gap: 'Y', padding: 'Z A', background: 'greenBg', borderRadius: 'Z', maxWidth: '80%',
          MsgFrom: { text: '{{ clientDashMsgFrom1 | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'green' },
          MsgText: { text: '{{ clientDashMsgText1 | polyglot }}', fontSize: 'Z', color: 'text', lineHeight: '1.6' },
          MsgTime: { text: '{{ clientDashMsgTime1 | polyglot }}', fontSize: 'Y', color: 'textMuted' },
        },
        Msg2: {
          flow: 'y', gap: 'Y', padding: 'Z A', background: 'surfaceBorder', borderRadius: 'Z', maxWidth: '80%', alignSelf: 'flex-end',
          MsgText: { text: '{{ clientDashMsgText2 | polyglot }}', fontSize: 'Z', color: 'text', lineHeight: '1.6' },
          MsgTime: { text: '{{ clientDashMsgTime2 | polyglot }}', fontSize: 'Y', color: 'textMuted', textAlign: 'right' },
        },
        Msg3: {
          flow: 'y', gap: 'Y', padding: 'Z A', background: 'greenBg', borderRadius: 'Z', maxWidth: '80%',
          MsgFrom: { text: '{{ clientDashMsgFrom3 | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'green' },
          MsgText: { text: '{{ clientDashMsgText3 | polyglot }}', fontSize: 'Z', color: 'text', lineHeight: '1.6' },
          MsgTime: { text: '{{ clientDashMsgTime3 | polyglot }}', fontSize: 'Y', color: 'textMuted' },
        },
      },

      MessageInput: {
        flow: 'x', gap: 'Z',
        MsgInput: { tag: 'input', type: 'text', name: 'message', placeholder: '{{ clientDashMsgPlaceholder | polyglot }}', padding: 'Z A', fontSize: 'A', background: 'surfaceMid', border: '1px solid surfaceBorderStrong', borderRadius: 'Z', color: 'text', flex: '1' },
        SendMsgBtn: { extends: 'Button', text: '{{ clientDashSend | polyglot }}', theme: 'primary', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', cursor: 'pointer' },
      },
    },
  },
}
